import { AxiosError } from 'axios';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetChapterNumbers, useGetCompanies } from '../../../../api/masters/masters';
import { ErrorInfo } from '../../../../api/model';
import { useGetOrganizationsTeams } from '../../../../api/origanization/origanization';
import { useGetPrivileges } from '../../../../api/privilege/privilege';
import { usePostUsersDetail } from '../../../../api/users/users';
import { useDefaultOptions } from '../../../../hooks/api';
import { UserNewForm } from './UserNewForm';

function UserNewFormPage() {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const options = useDefaultOptions(language);

  const companies = useGetCompanies(options);

  // グループ・チーム
  const teams = useGetOrganizationsTeams({}, options);

  // 権限リスト
  const priviledges = useGetPrivileges(options);

  // 原稿編集
  const chapterNumbers = useGetChapterNumbers(options);

  const { data, mutateAsync } = usePostUsersDetail<AxiosError<ErrorInfo>, unknown>(options);

  useEffect(() => {
    const postUserDetail = async () => {
      await mutateAsync({ data: { user_id: undefined } });
    };
    void postUserDetail();
  }, [mutateAsync]);

  const user = data?.data;
  if (!user) {
    return <div id="main">{t('お待ちください。')}</div>;
  }

  return (
    <UserNewForm
      companies={companies.data?.data.companies || []}
      priviledges={priviledges.data?.data.privileges_list_items || []}
      chapterNumbers={chapterNumbers.data?.data.chapter_numbers || []}
      teamCompanies={teams.data?.data.companies || []}
      user={user}
    />
  );
}

export default UserNewFormPage;
